import classNames from "classnames";
import styles from "./fix-loader.module.scss";
import { useLayoutType, LayoutStyleTypes, LayoutTypes } from "@/util-react/layout";
import { Icon } from "@/elements-react/fix-icon";
import loaderIconSpare1 from "@/assets/loader-icons/spare-1.svg";
import loaderIconSpare2 from "@/assets/loader-icons/spare-2.svg";
import loaderIconSpare3 from "@/assets/loader-icons/spare-3.svg";
import loaderIconSpare4 from "@/assets/loader-icons/spare-4.svg";

export interface FixLoaderProps {
  useIcon?: boolean,
  useCustomText?: boolean,
  customText?: string,
  loaderBackgroundMode?: "dark" | "light",
}

export const FixLoader = (props: FixLoaderProps) => {
  const { defaultLayoutStyleType } = useLayoutType();
  const { useIcon = false, useCustomText = false, customText = '', loaderBackgroundMode = 'light' } = props;

  return (
    <div className={classNames(styles.loader, styles[defaultLayoutStyleType], styles[loaderBackgroundMode])} >
      <div className={classNames(styles.loaderContent)}>
        {useCustomText && customText && (
            <div className={classNames(styles.text)}>
              {customText}
            </div>
        )}

        {useIcon && (
          <>
            <div className={classNames(styles.icons)}>
              <div className={classNames(styles.iconsLine)}>
                <Icon src={loaderIconSpare1} width={45} height={45} className={classNames(styles.icon)} />
                <Icon src={loaderIconSpare2} width={45} height={45} className={classNames(styles.icon)} />
                <Icon src={loaderIconSpare3} width={45} height={45} className={classNames(styles.icon)} />
                <Icon src={loaderIconSpare4} width={45} height={45} className={classNames(styles.icon)} />
                <Icon src={loaderIconSpare1} width={45} height={45} className={classNames(styles.icon)} />
              </div>
            </div>
            <div className={classNames(styles.ellipse)} >
              <div className={classNames(styles.ellipseItem, styles.left)} />
              <div className={classNames(styles.ellipseItem, styles.right)} />
            </div>
          </>
        )}
      </div>
    </div>
  );
};
